<template>
    <ContainerWithMenu>
        <div class="page-content">
            <div class="row margin-bottom-20">
                <div class="col-xs-9 col-md-7">
                    <ol class="breadcrumb">
                        <li><router-link :to="{name:'calendar'}">Home</router-link></li>
                        <li><router-link :to="{name:'marketing'}">{{$t('views.marketing.title')}}</router-link></li>
                        <li><router-link :to="{name:'showcases'}">{{$t('views.showcases.title')}}</router-link></li>
                        <li class="active">{{showcase.title}}</li>
                    </ol>
                </div>
                <div class="col-xs-3 col-md-5 text-right">
                    <button class="btn btn-default" @click="$router.push({name:'showcases'})">
                        <i class="las la-undo"></i>
                        <span class="button-text">{{$t('navigation.back_to_showcases')}}</span>
                    </button>
                </div>
            </div>
            <hr>
            <div class="row margin-bottom-20">
                <div class="col-xs-12 col-md-7">
                    <h1 class="h2 margin-0">{{showcase.title}}</h1>
                </div>
                <div class="col-xs-12 col-md-5 text-right">
                    <button class="btn btn-primary" @click.prevent.stop="showAddVideoShowcaseModal()">
                        <i class="las la-plus"></i>
                        <span class="button-text">{{ $t('views.showcase_detail.add_video') }}</span>
                    </button>
                    <button class="btn btn-default" @click.prevent.stop="showAddSeparatorModal()" style="margin-left: 10px">
                        <i class="las la-plus"></i>
                        <span class="button-text">{{ $t('views.showcase_detail.add_category') }}</span>
                    </button>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12 col-sm-6">
                    <div class="panel panel-default margin-bottom-40">
                        <div class="panel-heading">{{$t('views.showcase_detail.settings')}}</div>
                        <div class="panel-body">
                            <ShowcaseForm :showcase-prop="showcase" @change="onChangeShowcase"></ShowcaseForm>
                        </div>
                        <div class="panel-footer">
                            <a id="save-reservation-btn" href="" class="btn btn-default btn-lg btn-block margin-bottom-10"  @click.stop.prevent="saveShowcaseClick">
                                <i class="las la-check"></i>{{ $t('common.save_change') }}
                            </a>
                            <a href="" class="text-danger margin-bottom-20" @click.prevent.stop="deleteShowcaseModalVisible=true">{{$t('views.showcase_detail.delete')}}</a>
                        </div>
                    </div>
                    <h3>{{ $t('views.showcase_detail.showcase_link') }}</h3>
                    <div class="clearfix margin-bottom-20">
                        <div style="background-color:#f5f5f5;float:left;border-radius:6px;padding:12px 18px;">
                            <a :href="showcaseLink" target="_blank">{{showcaseLink}} <i class="las la-external-link-alt"></i></a>
                        </div>
                    </div>
                    <div
                            v-show="errorMessageShowcaseCopy"
                            class="alert alert-danger"
                            role="alert"
                    >
                        {{ errorMessageShowcaseCopy }}
                    </div>
                    <div
                            v-show="successMessageShowcaseCopy"
                            class="alert alert-success"
                            role="alert"
                    >
                        {{ successMessageShowcaseCopy }}
                    </div>
                    <button class="btn btn-default"
                            v-clipboard="() => showcaseLink"
                            v-clipboard:success="successShowcaseCopy"
                            v-clipboard:error="errorShowcaseCopy">
                        <i class="las la-copy"></i>{{ $t('views.showcase_detail.showcase_copy_link') }}
                    </button>
                </div>
                <div class="col-xs-12 col-sm-6">
                    <table class="table" style="border:1px solid #ddd;" v-if="videos && videos.length > 0">
                        <draggable v-model="videos" tag="tbody" v-bind="dragOptions"
                                   class="list-group"
                                   @start="drag = true"
                                   @end="endDrag()">
                            <tr v-for="(videoShowcase, index) in videos" v-bind:key="index">
                                <td class="active showcase-dragger" v-if="videoShowcase.separator"><i class="las la-bars"></i></td>
                                <td class="active" colspan="2" v-if="videoShowcase.separator" @dblclick="editSeparator(videoShowcase)">
                                    <div class="form-group" v-if="updatingSeparator && updatingSeparator.separator_id === videoShowcase.separator_id">
                                            <input type="text" id="showcase_title" name="showcase_title" placeholder="e.g., Hatha Yoga" class="form-control" v-model="updatingSeparator.separator_name">
                                    </div>
                                    <span v-else>{{videoShowcase.separator_name}}</span>
                                </td>
                                <td v-if="videoShowcase.separator && updatingSeparator && updatingSeparator.separator_id === videoShowcase.separator_id" class="active text-right">
                                    <a  href="" @click.prevent.stop="updateSeparatorClick(showcase.id, updatingSeparator.separator_id, updatingSeparator.separator_name)" class="btn btn-default" ><i class="las la-check margin-0"></i></a>
                                </td>
                                <td v-else-if="videoShowcase.separator && (!updatingSeparator || (updatingSeparator && updatingSeparator.separator_id === videoShowcase.separator_id))" class="active text-right">
                                    <a  href="" @click.prevent.stop="editSeparator(videoShowcase)" class="btn btn-default" ><i class="las la-edit margin-0"></i></a>
                                </td>
                                <td v-if="videoShowcase.separator" class="active text-right">
                                    <a href="" @click.prevent.stop="removeSeparatorClick(showcase.id, videoShowcase.separator_id)" class="btn btn-default"><i class="las la-trash margin-0"></i></a>
                                </td>
                                <td class="showcase-dragger" v-if="!videoShowcase.separator"><i class="las la-bars"></i></td>
                                <td v-if="!videoShowcase.separator" width="101">
                                    <router-link :to="{ name: 'video_detail', params: { video_id: videoShowcase.video.id }}" target="_blank">
                                        <img class="img-rounded img-responsive" :src="'https://i.vimeocdn.com/video/' + videoShowcase.video.picture_id + '-' + videoShowcase.video.picture_key +'-d_300x180'">
                                    </router-link>
                                </td>
                                <td v-if="!videoShowcase.separator">
                                    <h5 class="margin-bottom-5">{{videoShowcase.video.title}}</h5>
                                    <span :class="getClassLabelVisibilityVideo(videoShowcase.video.visibility)" class="label">{{getStringVisibilityVideo(videoShowcase.video.visibility)}}</span>
                                    <span v-if="videoShowcase.video.archived" style="margin-left: 5px" class="label label-default">{{$t('components.video.archived')}}</span>
                                </td>
                                <td v-if="!videoShowcase.separator">{{getDurationTime(videoShowcase.video.duration)}}</td>
                                <td v-if="!videoShowcase.separator" class="text-right">
                                    <a href="" @click.prevent.stop="removeVideoFromVideoClick(showcase.id, videoShowcase.video.id)" class="btn btn-danger"><i class="las la-trash margin-0 white-color"></i></a>
                                </td>
                            </tr>
                        </draggable>
                    </table>
                    <div v-else>
                        <span class="text-muted">{{ $t('views.showcases.video_not_found') }}</span>
                    </div>
                </div>
            </div>
        </div>
        <SpinnerLoader v-show="loading"></SpinnerLoader>
        <AddVideoShowcaseModal v-if="showcase.id"
                v-show="visibleAddVideoShowcaseModal"
                :visible="visibleAddVideoShowcaseModal"
                @close-add-video-showcase-modal="closeAddVideoShowcaseModal"
                @success-add-video-showcase-modal="successAddVideoShowcaseModal"
                :selected-videos-prop="showcaseVideosID"
                :showcase-id="showcase.id"></AddVideoShowcaseModal>
        <GenericChooseModal
                :message="$t('views.showcase_detail.modal_delete_message')"
                :title="$t('views.showcase_detail.delete')"
                :visible="deleteShowcaseModalVisible"
                :positive-button-text="$t('views.showcase_detail.modal_delete_positive')"
                :negative-button-text="$t('views.showcase_detail.modal_delete_negative')"
                danger
                @positive-click-generic-modal="positiveButtonDeleteShowcaseModalClick"
                @negative-click-generic-modal="negativeButtonDeleteShowcaseModalClick"
                @close-generic-modal="negativeButtonDeleteShowcaseModalClick"
        />

        <AddSeparatorModal v-if="showcase.id"
                               v-show="visibleAddSeparatorModal"
                               :visible="visibleAddSeparatorModal"
                               @close-separator-modal="closeAddSeparatorModal"
                               @success-add-separator-modal="successAddSeparatorModal"
                               :selected-videos-prop="showcaseVideosID"
                               :showcase-id="showcase.id"></AddSeparatorModal>
    </ContainerWithMenu>
</template>

<script>
    import draggable from "vuedraggable";
    import ContainerWithMenu from "../components/container/ContainerWithMenu";
    import SpinnerLoader from "../components/common/SpinnerLoader";
    import i18n from "../i18n";
    import ShowcaseForm from "../components/showcase/ShowcaseForm";
    import {
        deleteSeparator,
        deleteShowcase,
        deleteVideoFromShowcase,
        getShowcaseDetail, updateSeparator,
        updateShowcase,
        updateVideoShowcase
    } from "../api";
    import {Utils} from "../common/utils";
    import AddVideoShowcaseModal from "../components/modal/AddVideoShowcaseModal";
    import GenericChooseModal from "../components/modal/GenericChooseModal";
    import {URL_SHOWCASE} from "../common/constants";
    import AddSeparatorModal from "../components/modal/AddSeparatorModal";

    ////TODO translate this page and make dynamic this page
    export default {
        title: i18n.t('views.showcase_detail.title'),
        name: "ShowcaseDetail",
        components: { ContainerWithMenu, SpinnerLoader, ShowcaseForm, AddVideoShowcaseModal, GenericChooseModal, draggable, AddSeparatorModal },
        data: function () {
            return {
                loading: false,
                showcase: {},
                successMessageShowcaseCopy: null,
                errorMessageShowcaseCopy: null,
                visibleAddVideoShowcaseModal: false,
                deleteShowcaseModalVisible: false,
                visibleAddSeparatorModal: false,
                drag: false,
                videos: [],
                updatingSeparator: null
            }
        },
        async mounted() {
            this.getShowcaseData()
        },
        methods: {
            editSeparator(separator) {
              this.updatingSeparator = separator
            },
            successShowcaseCopy() {
                this.successMessageShowcaseCopy = i18n.t('views.showcase_detail.showcase_copy_success');
                this.errorMessageShowcaseCopy = '';
            },
            errorShowcaseCopy() {
                this.errorMessageShowcaseCopy = i18n.t('views.showcase_detail.showcase_copy_fail');
                this.successMessageShowcaseCopy = '';
            },
            async getShowcaseData() {
                this.loading = true;
                try {
                    this.showcase = await getShowcaseDetail(this.$route.params.showcase_id);
                    this.loading = false;
                } catch (e) {
                    this.loading = false;
                    console.log(e)
                }
            },
            showAddVideoShowcaseModal(){
                this.visibleAddVideoShowcaseModal = true;
            },
            showAddSeparatorModal(){
                this.visibleAddSeparatorModal = true;
            },
            closeAddVideoShowcaseModal() {
                this.visibleAddVideoShowcaseModal = false;
            },
            successAddVideoShowcaseModal() {
                this.visibleAddVideoShowcaseModal = false;
                this.getShowcaseData();
            },
            closeAddSeparatorModal() {
                this.visibleAddSeparatorModal = false;
            },
            successAddSeparatorModal() {
                this.visibleAddSeparatorModal = false;
                this.getShowcaseData()
            },
            async positiveButtonDeleteShowcaseModalClick() {
                this.loading = true;
                try {
                    await deleteShowcase(this.showcase.id);
                    this.loading = false;
                    this.deleteShowcaseModalVisible = false;
                    this.$nextTick(() => {
                        this.$router.push({ name: 'showcases', params: { successMessage: i18n.t('views.showcase_detail.delete_success') }});
                    });
                } catch (e) {
                    this.loading = false;
                    console.log(e)
                }
            },
            negativeButtonDeleteShowcaseModalClick() {
                this.deleteShowcaseModalVisible = false
            },
            async saveShowcaseClick() {
                this.loading = true;
                await updateShowcase(
                    this.$route.params.showcase_id,
                    this.showcase.title,
                    this.showcase.description,
                    this.showcase.state,
                    this.showcase.privacy,
                    this.showcase.password,
                    this.showcase.price);
                try {

                    this.loading = false;
                    this.$route.params.successMessage = i18n.t('views.showcase_detail.update_success');
                } catch (e) {
                    this.loading = false;
                    console.log(e)
                }
            },
            async removeVideoFromVideoClick(showcase_id, video_id) {
                this.loading = true;
                try {
                    await deleteVideoFromShowcase(showcase_id, video_id);
                    this.showcase = await getShowcaseDetail(this.$route.params.showcase_id);
                    this.loading = false;
                } catch (e) {
                    console.log(e);
                    this.loading = false;
                }
            },

            async removeSeparatorClick(showcase_id, separator_id) {
                this.loading = true;
                try {
                    await deleteSeparator(showcase_id, separator_id);
                    this.showcase = await getShowcaseDetail(this.$route.params.showcase_id);
                    this.loading = false;
                } catch (e) {
                    console.log(e);
                    this.loading = false;
                }
            },

            async updateSeparatorClick(showcase_id, separator_id, separator_name) {
                this.loading = true;
                try {
                    await updateSeparator(showcase_id, separator_id, separator_name);
                    this.showcase = await getShowcaseDetail(this.$route.params.showcase_id);
                    this.loading = false;
                    this.updatingSeparator = null
                } catch (e) {
                    console.log(e);
                    this.loading = false;
                }
            },
            onChangeShowcase(showcase) {
                this.showcase = showcase;
            },
            getLongDateFromISO(date){
                return Utils.getLongDateFromISO(date)
            },
            getClassLabelVisibilityVideo(visibility) {
                return Utils.getClassLabelVisibilityVideo(visibility)
            },
            getStringVisibilityVideo(visibility) {
                return Utils.getStringVisibilityVideo(visibility)
            },
            getDurationTime(seconds) {
                return Utils.getDurationTime(seconds)
            },
            closeShowcaseVideoModal() {
                this.visibleAddVideoShowcaseModal=false
            },
            getNameCategory(category_id) {
                for (let i = 0; i < this.showcase.categories.length; i++ ) {
                    if (this.showcase.categories[i].id === category_id) {
                        return this.showcase.categories[i].name
                    }
                }
                return ""
            },
            saveVideosWithSeparator(videos, categories_unselected) {
                let videosWithSeparator = [];
                for (let i = 0; i < videos.length; i++) {
                    if (i === 0) {
                        if (videos[i].category != null) {
                            videosWithSeparator.push({ separator: true, separator_name: this.getNameCategory(videos[i].category), separator_id: videos[i].category});
                        }
                    } else if (videos[i].category !== videos[i-1].category) {
                        if (videos[i].category != null) {
                            videosWithSeparator.push({ separator: true, separator_name: this.getNameCategory(videos[i].category), separator_id: videos[i].category});
                        }
                    }
                    videosWithSeparator.push(videos[i])

                }

                for (let i = 0; i < categories_unselected.length; i++) {
                    videosWithSeparator.push({ separator: true, separator_name: categories_unselected[i].name, separator_id: categories_unselected[i].id});
                }
                this.videos = videosWithSeparator;
            },
            async endDrag() {
                this.drag = false;

                this.loading = true;
                try {
                    await updateVideoShowcase(this.$route.params.showcase_id, this.videos);
                    this.getShowcaseData();
                    this.loading = false;
                } catch (e) {
                    this.loading = false;
                    console.log(e)
                }
            }
        },
        computed: {
            dragOptions() {
                return {
                    animation: 200,
                    group: "description",
                    disabled: false,
                    ghostClass: "ghost"
                };
            },
            showcaseLink() {
                return URL_SHOWCASE + this.showcase.fingerprint
            },
            showcaseVideosID() {
                let videosId = [];

                if (!this.showcase.videos) {
                    return []
                }

                for (let i = 0; i < this.showcase.videos.length; i++) {
                    videosId.push(this.showcase.videos[i].video.id)
                }

                return videosId;
            },
        },
        watch: {
            "showcase.videos"(newVal) {
                this.saveVideosWithSeparator(newVal, this.showcase.categories_unselected)
            }
        }

    };
</script>

<style>
    .button {
        margin-top: 35px;
    }
    .flip-list-move {
        transition: transform 0.5s;
    }
    .no-move {
        transition: transform 0s;
    }
    .ghost {
        opacity: 0.5;
        background: #c8ebfb;
    }
    .list-group {
        min-height: 20px;
    }
    .list-group-item {
        cursor: move;
    }
    .list-group-item i {
        cursor: pointer;
    }
</style>
